import React, { useEffect, useRef } from 'react';

import Quill from 'quill';
// @ts-ignore
import ImageResize from 'quill-image-resize-module-react';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';

// Register Image Resize Module
Quill.register('modules/imageResize', ImageResize);

type QuillEditorProps = {
  value: string;
  onChange: (val: string) => void;
};

const QuillEditor: React.FC<QuillEditorProps> = ({ value, onChange }) => {
  const quillRef = useRef<ReactQuill>(null);

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      if (quill) {
        const toolbar = quill.getModule('toolbar');

        // Custom Image Handler
        const imageHandler = () => {
          const imageUrl = prompt('Enter image URL');
          if (imageUrl) {
            const range = quill.getSelection();
            if (range) {
              quill.insertEmbed(range.index, 'image', imageUrl);
            }
          }
        };

        toolbar.addHandler('image', imageHandler);
      }
    }
  }, []);

  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      ['link', 'image'], // Image button in toolbar
    ],
    imageResize: {
      displaySize: true, // Show image dimensions
      modules: ['Resize', 'DisplaySize', 'Toolbar'], // Enables resizing
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    'header',
    'font',
    'list',
    'bullet',
    'bold',
    'italic',
    'underline',
    'align',
    'link',
    'image',
  ];

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
    />
  );
};

export default QuillEditor;
